import { slugs } from '@/constants/slugs'

export interface QuantityMultiplierType {
  min: number
  max: number
  multiplier: number
}
export const QuantityMultipliers: Record<string, QuantityMultiplierType[]> = {
  [slugs.kingOfKings]: [
    { min: 1, max: 2, multiplier: 2 },
    { min: 3, max: 4, multiplier: 3 },
    { min: 5, max: 9, multiplier: 5 },
    { min: 10, max: 24, multiplier: 10 },
    { min: 25, max: Infinity, multiplier: 25 },
  ],
  [slugs.theLastRodeo]: [
    { min: 1, max: 2, multiplier: 2 },
    { min: 3, max: 4, multiplier: 3 },
    { min: 5, max: 9, multiplier: 5 },
    { min: 10, max: 24, multiplier: 10 },
    { min: 25, max: Infinity, multiplier: 25 },
  ],
}
